import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { cloneDeep, flatMap } from 'lodash';
import { useSelector } from 'react-redux';
import { customStylesForOCP, ColumnValues } from '../../../../../Components/helper';
import BtnAdd from '../../../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../../../Components/Utility/FilterAction/BtnDelete';

function TableDependent({ relation, columnIndex, handleChange, hasError, deleteCard, addContent, i }) {
  const { t } = useTranslation('common');
  const dependentLanguagePath = 'CUSTOM_LIBRARY.DEPENDENT_SETTING';
  const {
    CustomModuleReducer: { customLibraryDetail },
  } = useSelector((reducer) => reducer);
  const [cmOptions, setCmOptions] = useState([]);
  useEffect(() => {
    if (customLibraryDetail) {
      const clonedCustomModule = cloneDeep(customLibraryDetail);
      const customModuleDropDowns = clonedCustomModule?.pages?.map((page) => {
        return page?.grid?.filter((grid) => grid?.control && grid?.control.key === 'Table').map((control) => ({ ...control, pageId: page?._id }));
      });
      setCmOptions(flatMap(customModuleDropDowns));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customLibraryDetail]);

  function checkColourArray() {
    let valid = true;
    relation?.colourArray.forEach((element) => {
      if ((element?.colourValue === 'between' && !element?.endPercentage) || (element?.colourValue && !element?.startPercentage?.trim()?.length)) {
        valid = false;
      }
    });
    return valid;
  }

  const checkingFromDynamicArray = (value) => {
    return typeof value === 'object' ? ColumnValues?.find((ele) => ele?._id === value?._id) : ColumnValues?.find((ele) => ele?._id === value);
  };

  const isContentOption = () => {
    let options = relation?.isControlOptions || [];
    if (relation?.isContentArr?.length > 0) {
      options = options.filter((e) => !relation?.isContentArr?.map((ele) => ele?.isContent?.label).includes(e?.label));
    }
    return options;
  };

  const handleFixedDropDownControlOptions = () => {
    const finalColumns = [];
    cmOptions?.forEach((e) => {
      if (e?.control?.key === 'Table' && e?.i?.toString() === i?.toString()) {
        if (e?.control?.tableColumns?.length > 0) {
          e?.control?.tableColumns?.forEach((ele, eleIndex) => {
            if (ele?.key === 'Dropdown') {
              finalColumns.push({
                control: { ...ele, label: `${ele?.fieldName} - ${e?.control?.labelInModal || 'Table'}` },
                i: `${eleIndex}_${ele?.fieldName}_${e?.control?.labelInModal || 'Table'}`,
              });
            }
          });
        }
      }
    });
    return finalColumns;
  };

  const handleNumberPercentFromTable = () => {
    const finalNumberColumn = [];
    cmOptions?.forEach((e) => {
      if (e?.control?.key === 'Table' && e?.i?.toString() === i?.toString()) {
        if (e?.control?.tableColumns?.length > 0) {
          const clonedTable = cloneDeep(e?.control?.tableColumns);
          clonedTable?.forEach((ele, colIndex) => {
            if (['Number_Decimal', 'Number_Percentage'].includes(ele?.key)) {
              finalNumberColumn.push({
                control: { ...ele, label: `${ele?.fieldName} - ${e?.control?.labelInModal || 'Table'}` },
                i: `${colIndex}_${columnIndex}_${e?.control?.labelInModal || 'Table'}`,
              });
            }
          });
        }
      }
    });
    return finalNumberColumn;
  };

  function dropDownControlOptions() {
    return relation?.fixed ? handleFixedDropDownControlOptions() : handleNumberPercentFromTable() || [];
  }
  return (
    <Row>
      <Col lg={12} className="mt-2 mb-2">
        <p className="asterisk-req f-14 mb-0">{t(`${dependentLanguagePath}.DEPENDENT_TYPE`)}</p>
        <div>
          <div className="d-flex align-items-center">
            <p className="custom-radio">
              <input
                type="radio"
                id={`dependentFixed_${columnIndex}`}
                name={`dependentFixed_${columnIndex}`}
                checked={relation?.fixed}
                onChange={(e) => handleChange('fixed', e?.target?.checked, ['dropDownControl', 'isContentArr', 'colourArray'], -1, -1, columnIndex)}
              />
              <label htmlFor={`dependentFixed_${columnIndex}`}>{t(`${dependentLanguagePath}.DEPENDENT_FIXED`)}</label>
            </p>
            <p className="custom-radio ml-4">
              <input
                type="radio"
                id={`dependentRange_${columnIndex}`}
                name={`dependentRange_${columnIndex}`}
                checked={!relation?.fixed}
                onChange={(e) => handleChange('fixed', !e?.target?.checked, ['dropDownControl', 'isContentArr', 'colourArray'], -1, -1, columnIndex)}
              />
              <label htmlFor={`dependentRange_${columnIndex}`}>{t(`${dependentLanguagePath}.DEPENDENT_RANGE`)}</label>
            </p>
          </div>
        </div>
      </Col>
      <Col lg="12" className="mb-2">
        <p className="asterisk-req f-14 mb-1">
          {t(`${dependentLanguagePath}.IF_TITLE_NAME`)} <span>*</span>
        </p>
        <Select
          name="dropDownControl"
          options={dropDownControlOptions()}
          getOptionLabel={(option) => `${option?.control?.label}`}
          getOptionValue={(option) => `${option?.i}`}
          value={relation?.dropDownControl}
          styles={customStylesForOCP}
          className="common-select"
          classNamePrefix="common-select"
          maxMenuHeight={120}
          menuPosition="fixed"
          placeholder={t(`${dependentLanguagePath}.SELECT_CONTROL`)}
          onChange={(selected) => handleChange('dropDownControl', selected, ['isContentArr', 'colourArray'], -1, -1, columnIndex)}
          isClearable
        />
        {hasError && !relation?.dropDownControl && <span className="error-message">{t(`${dependentLanguagePath}.IF_TITLE_NAME_MISSING`)}</span>}
      </Col>
      {relation?.fixed ? (
        relation?.isContentArr?.map((element, contentIndex) => {
          return (
            <Col lg="12" className="d-flex mb-1" key={`${contentIndex}_${columnIndex}_${element}`}>
              <div className="card card-body d-flex flex-row p-2 rounded-0">
                <div className="mb-2 flex-fill mx-2">
                  <div className="common-react-select mb-0">
                    <p className="field-name">
                      {t(`${dependentLanguagePath}.IS_CONTENT`)} <span>*</span>
                    </p>
                    <Select
                      name="is Option"
                      options={isContentOption()}
                      getOptionLabel={(option) => `${option?.label}`}
                      getOptionValue={(option) => `${option?.id}`}
                      value={element?.isContent}
                      styles={customStylesForOCP}
                      className="common-select"
                      classNamePrefix="common-select"
                      maxMenuHeight={120}
                      menuPosition="fixed"
                      placeholder={t(`${dependentLanguagePath}.SELECT_OPTION`)}
                      onChange={(selected) => handleChange('isContent', selected, [], -1, contentIndex, columnIndex)}
                    />
                    {hasError && !element?.isContent && <span className="error-message">{t(`${dependentLanguagePath}.IS_CONTENT_MISSING`)}</span>}
                  </div>
                </div>
                <div className="mb-2 flex-fill mx-2">
                  <div className="common-input-control mb-0">
                    <p className="field-name">
                      {t(`${dependentLanguagePath}.TO`)} <span>*</span>
                    </p>
                    <input
                      type="text"
                      name="to"
                      placeholder={t(`${dependentLanguagePath}.ENTER_TO`)}
                      className="form-control f-14"
                      maxLength={50}
                      value={element?.to}
                      onChange={(e) => handleChange('to', e?.target?.value, [], -1, contentIndex, columnIndex)}
                    />
                  </div>
                  {hasError && !element?.to?.trim().length && <span className="error-message">{t(`${dependentLanguagePath}.IS_TO_MISSING`)}</span>}
                </div>
              </div>
              <div className="btn-outline-container">
                {relation?.isControlOptions?.length > 0 && (relation?.isContentArr?.length ?? -1) - 1 === contentIndex && (
                  <BtnAdd
                    onBtnClick={() => addContent(columnIndex)}
                    addEditAccess
                    forDisable={relation?.isControlOptions?.length === relation?.isContentArr?.length}
                  />
                )}
                <div className="mb-1" />
                {relation?.isContentArr?.length > 1 && <BtnDelete multiDelete={() => deleteCard(columnIndex, contentIndex)} addEditAccess />}
              </div>
            </Col>
          );
        })
      ) : (
        <div className="col-lg-12 d-flex flex-column">
          {relation?.colourArray?.map((element, colourIndex) => {
            return (
              <div className="d-flex align-items-center f-14 mb-2" key={`colourArray_${element?.colourType}_${columnIndex}`}>
                <div className="status-color-container d-flex">
                  <span className={`${element?.colourType} rount-shape`} />
                </div>
                <div className="d-flex flex-wrap align-items-center">
                  <span className="px-2 text-nowrap">if</span>
                  <div className="w-180 px-2 my-1 my-md-0">
                    <Select
                      name="colourValue"
                      options={ColumnValues?.filter((ele) => !relation?.colourArray?.map((e) => e?.colourValue)?.includes(ele?._id))}
                      getOptionLabel={(option) => `${option.name}`}
                      getOptionValue={(option) => `${option._id}`}
                      menuPlacement="bottom"
                      menuPosition="fixed"
                      isClearable
                      menuShouldBlockScroll
                      menuShouldScrollIntoView
                      value={checkingFromDynamicArray(element?.colourValue) || null}
                      styles={customStylesForOCP}
                      maxMenuHeight={140}
                      onChange={(e) => handleChange('colourValue', e?._id, ['startPercentage', 'endPercentage'], colourIndex, -1, columnIndex)}
                      placeholder={t(`${dependentLanguagePath}.SELECT_VALUE`)}
                    />
                  </div>
                  <input
                    className="form-control text-bordered percentaage-input mx-2"
                    onChange={(e) => handleChange('startPercentage', e?.target?.value, [], colourIndex, -1, columnIndex)}
                    disabled={!element?.colourValue}
                    value={element?.startPercentage || ''}
                    name={`colourStateValue_start_${colourIndex}`}
                    type="number"
                  />{' '}
                  %
                  {element?.colourValue === 'between' && (
                    <div className="d-flex align-items-center ml-1">
                      {' and '}
                      <input
                        className="form-control text-bordered percentaage-input mx-2"
                        onChange={(e) => handleChange('endPercentage', e?.target?.value, [], colourIndex, -1, columnIndex)}
                        disabled={!element?.colourValue}
                        value={element?.endPercentage || ''}
                        name={`colourStateValue_end_${colourIndex}`}
                        type="number"
                      />{' '}
                      %
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {hasError && !checkColourArray() && <span className="error-message">{t(`${dependentLanguagePath}.IS_COLOUR_ARRAY_MISSING`)}</span>}
        </div>
      )}
    </Row>
  );
}

export default TableDependent;
